import React from 'react';
import './App.css';
import Nav from './components/NavBar';
import Header from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Education from './components/Education';
import Publications from './components/Publication';
import Awards from './components/Awards';
import Presentation from './components/Presentation';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  // Available Colours:
  // blue, cyan, gray, green, orange, pink, purple, red, teal, yellow

  // edit this variable to change the color theme
  const color = "teal";

  return (
    <>
      <Nav color={color} />
      <Header color={color} />
      <About color={color} />
      <Education color={color} />
      <Experience color={color} />
      <Skills color={color} />
      <Projects color={color} />
      <Publications color={color} />
      <Presentation color={color} />
      <Awards color={color} />
      <Contact color={color} />
      <Footer />
    </>
  );
}

export default App;
